import React, { useEffect, useState } from 'react';
import {
	CheckCircle,
	MailSendEnvelope,
	PencilSquare,
	UserSingleNeutral,
} from '@sharefiledev/icons';
import { Col, Flex, Row, Steps, Tag, theme, Typography } from 'antd';
import { useAppStore } from '../../../common/store';
import { ICON_SIZE } from '../../../constants';
import { t } from '../../../utils';
import { getStepsConfig } from '../stepsConfig';

const { Title } = Typography;

const iconMapping = {
	UsersOutlined: <UserSingleNeutral size={ICON_SIZE} />,
	PencilSquareOutlined: <PencilSquare size={ICON_SIZE} />,
	CheckCircleFilled: <CheckCircle size={ICON_SIZE} />,
	MailSendEnvelopeOutlined: <MailSendEnvelope size={ICON_SIZE} />,
};

export const SignatureRequestHeader = () => {
	const { signatureMetadata, document } = useAppStore(state => ({
		signatureMetadata: state.signatureMetadata,
		document: state.document,
	}));
	const [steps, setSteps] = useState([]);
	const { token } = theme.useToken();

	useEffect(() => {
		if (signatureMetadata) {
			setSteps(
				getStepsConfig(signatureMetadata).map(step => ({
					...step,
					icon: iconMapping[step.icon as keyof typeof iconMapping],
				}))
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [signatureMetadata?.currentStep]);

	return (
		<Row>
			<Col span={8}>
				<Flex align="center" gap="small" style={{ margin: token.marginXS }}>
					<Title level={4} style={{ margin: '0px' }}>
						{t('SendSignatureRequest.title')}
					</Title>
					<Tag>{t('SendSignatureRequest.tag')}</Tag>
				</Flex>
			</Col>
			<Col span={8}>
				{document && (
					<Steps
						items={steps}
						size="small"
						style={{
							height: '100%',
							alignItems: 'center',
						}}
					/>
				)}
			</Col>
		</Row>
	);
};
